<div class="main-container" *ngIf="!isLoading" data-cy="note-builder-main-container">

  <div *ngIf="showContext" data-cy="note-builder-context-wrapper">
    <app-note-builder-context
      [positionX]="contextPositionX"
      [positionY]="contextPositionY"
      [actionsDisabled]="disableContextActions"
      [allowEditOptions]="allowEditOptions"
      [dataPredefinedNote]="activeContextNote"
      (addNew)="addNewPredefinedNoteUnder(false)"
      (delete)="deleteContext()"
      (edit)="addNewPredefinedNoteUnder(true)"
      (addSeperator)="addSeperator($event)">
    </app-note-builder-context> 
  </div>

  <div class="note-phrase-container" (click)="hideContextMenu()" oncontextmenu="return false;" data-cy="note-builder-phrase-container">

    <div cdkDropList
         #dropList1="cdkDropList"
         [cdkDropListDisabled]="!draggingEnabled"
         [cdkDropListData]="predefinedNoteOrganizer[0]"
         [cdkDropListConnectedTo]="[dropList2, dropList3, dropList4, dropList5]"
         (cdkDropListDropped)="drop($event)"
         class="parent-holder"
         data-cy="note-builder-droplist-1">
      <div class="predefined-note-content" *ngFor="let predefinedNote of predefinedNoteOrganizer[0]; let i = index" (contextmenu)="onRightClickEvent($event, predefinedNote)" cdkDrag data-cy="note-builder-note-item-1">
        <div [class.clickable]="!predefinedNote.isSeparator && predefinedNote.NoteDescription !== separatorString && !(i != 0 && predefinedNoteOrganizer[0][i - 1].NoteDescription == separatorString)"
             [class.clicked]="noteHasTemplate(predefinedNote)"
             matTooltip="{{ predefinedNote.NoteTemplate }}" matTooltipDisabled="{{ predefinedNote.isSeparator }}"
             (click)="addToNote(predefinedNote, i != 0 ? predefinedNoteOrganizer[0][i - 1] : null)"
             [class.section-header]="i != 0 && predefinedNoteOrganizer[0][i - 1].NoteDescription == separatorString"
             data-cy="note-builder-note-text-1">
          {{ predefinedNote.NoteDescription }}
        </div>
      </div>
      <div class="under-div" *ngIf="predefinedNoteOrganizer[0].length < 27"
           (contextmenu)="onRightClickEmptyEvent($event, null, 0)" 
           data-cy="note-builder-empty-area-1">
      </div>
    </div>

    <div cdkDropList
         #dropList2="cdkDropList"
         [cdkDropListDisabled]="!draggingEnabled"
         [cdkDropListData]="predefinedNoteOrganizer[1]"
         [cdkDropListConnectedTo]="[dropList1, dropList3, dropList4, dropList5]"
         (cdkDropListDropped)="drop($event)"
         class="parent-holder"
         data-cy="note-builder-droplist-2">
      <div class="predefined-note-content" *ngFor="let predefinedNote of predefinedNoteOrganizer[1]; let i = index" (contextmenu)="onRightClickEvent($event, predefinedNote)" cdkDrag data-cy="note-builder-note-item-2">
        <div [class.clickable]="!predefinedNote.isSeparator && predefinedNote.NoteDescription !== separatorString && !(i != 0 && predefinedNoteOrganizer[1][i - 1].NoteDescription == separatorString)"
             [class.clicked]="noteHasTemplate(predefinedNote)"
             matTooltip="{{ predefinedNote.NoteTemplate }}" matTooltipDisabled="{{ predefinedNote.isSeparator }}"
             (click)="addToNote(predefinedNote, i != 0 ? predefinedNoteOrganizer[1][i - 1] : null)"
             [class.section-header]="i != 0 && predefinedNoteOrganizer[1][i - 1].NoteDescription == separatorString"
             data-cy="note-builder-note-text-2">
          {{ predefinedNote.NoteDescription }}
        </div>
      </div>
      <div class="under-div" *ngIf="predefinedNoteOrganizer[1].length < 27" (contextmenu)="onRightClickEmptyEvent($event, null, 1)" data-cy="note-builder-empty-area-2">
      </div>
    </div>

    <div cdkDropList
         #dropList3="cdkDropList"
         [cdkDropListDisabled]="!draggingEnabled"
         [cdkDropListData]="predefinedNoteOrganizer[2]"
         [cdkDropListConnectedTo]="[dropList1, dropList2, dropList4, dropList5]"
         (cdkDropListDropped)="drop($event)"
         class="parent-holder"
         data-cy="note-builder-droplist-3">
      <div class="predefined-note-content" *ngFor="let predefinedNote of predefinedNoteOrganizer[2]; let i = index" (contextmenu)="onRightClickEvent($event, predefinedNote)" cdkDrag data-cy="note-builder-note-item-3">
        <div [class.clickable]="!predefinedNote.isSeparator && predefinedNote.NoteDescription !== separatorString && !(i != 0 && predefinedNoteOrganizer[2][i - 1].NoteDescription == separatorString)"
             [class.clicked]="noteHasTemplate(predefinedNote)" matTooltip="{{ predefinedNote.NoteTemplate }}"
             matTooltipDisabled="{{ predefinedNote.isSeparator }}"
             (click)="addToNote(predefinedNote, i != 0 ? predefinedNoteOrganizer[2][i - 1] : null)"
             [class.section-header]="i != 0 && predefinedNoteOrganizer[2][i - 1].NoteDescription == separatorString"
             data-cy="note-builder-note-text-3">
          {{ predefinedNote.NoteDescription }}
        </div>
      </div>
      <div class="under-div" *ngIf="predefinedNoteOrganizer[2].length < 27" (contextmenu)="onRightClickEmptyEvent($event, null, 2)" data-cy="note-builder-empty-area-3">
      </div>
    </div>

    <div cdkDropList
         #dropList4="cdkDropList"
         [cdkDropListDisabled]="!draggingEnabled"
         [cdkDropListData]="predefinedNoteOrganizer[3]"
         [cdkDropListConnectedTo]="[dropList1, dropList2, dropList3, dropList5]"
         (cdkDropListDropped)="drop($event)"
         class="parent-holder"
         data-cy="note-builder-droplist-4">
      <div class="predefined-note-content" *ngFor="let predefinedNote of predefinedNoteOrganizer[3]; let i = index" (contextmenu)="onRightClickEvent($event, predefinedNote)" cdkDrag data-cy="note-builder-note-item-4">
        <div [class.clickable]="!predefinedNote.isSeparator && predefinedNote.NoteDescription !== separatorString && !(i != 0 && predefinedNoteOrganizer[3][i - 1].NoteDescription == separatorString)"
             [class.clicked]="noteHasTemplate(predefinedNote)" matTooltip="{{ predefinedNote.NoteTemplate }}"
             matTooltipDisabled="{{ predefinedNote.isSeparator }}"
             (click)="addToNote(predefinedNote, i != 0 ? predefinedNoteOrganizer[3][i - 1] : null)"
             [class.section-header]="i != 0 && predefinedNoteOrganizer[3][i - 1].NoteDescription == separatorString"
             data-cy="note-builder-note-text-4">
          {{ predefinedNote.NoteDescription }}
        </div>
      </div>
      <div class="under-div" *ngIf="predefinedNoteOrganizer[3].length < 27" (contextmenu)="onRightClickEmptyEvent($event, null, 3)" data-cy="note-builder-empty-area-4">
      </div>
    </div>

    <div cdkDropList
         #dropList5="cdkDropList"
         [cdkDropListDisabled]="!draggingEnabled"
         [cdkDropListData]="predefinedNoteOrganizer[4]"
         [cdkDropListConnectedTo]="[dropList1, dropList2, dropList3, dropList4]"
         (cdkDropListDropped)="drop($event)"
         class="parent-holder"
         data-cy="note-builder-droplist-5">
      <div class="predefined-note-content" *ngFor="let predefinedNote of predefinedNoteOrganizer[4]; let i = index" (contextmenu)="onRightClickEvent($event, predefinedNote)" cdkDrag data-cy="note-builder-note-item-5">
        <div [class.clickable]="!predefinedNote.isSeparator && predefinedNote.NoteDescription !== separatorString && !(i != 0 && predefinedNoteOrganizer[4][i - 1].NoteDescription == separatorString)"
             [class.clicked]="noteHasTemplate(predefinedNote)" matTooltip="{{ predefinedNote.NoteTemplate }}"
             matTooltipDisabled="{{ predefinedNote.isSeparator }}"
             (click)="addToNote(predefinedNote, i != 0 ? predefinedNoteOrganizer[4][i - 1] : null)"
             [class.section-header]="i != 0 && predefinedNoteOrganizer[4][i - 1].NoteDescription == separatorString"
             data-cy="note-builder-note-text-5">
          {{ predefinedNote.NoteDescription }}
        </div>
      </div>
      <div class="under-div" *ngIf="predefinedNoteOrganizer[4].length < 27" (contextmenu)="onRightClickEmptyEvent($event, null, 4)" data-cy="note-builder-empty-area-5">
      </div>
    </div>

  </div>
  <div class="preview-note-container" (click)="hideContextMenu()" data-cy="note-builder-preview-container">
    <mat-divider data-cy="note-builder-divider"></mat-divider>
    <mat-form-field class="note-form-field" data-cy="note-builder-textarea-field">
      <textarea matInput class="note-text-area" placeholder="Leave a note" [(ngModel)]="note" [matTextareaAutosize]="false" [rows]="10" data-cy="note-builder-textarea-input"></textarea>
    </mat-form-field>
  </div>
  <div class="action-container" (click)="hideContextMenu()" data-cy="note-builder-action-container">

    <button mat-button class="action-button drag-button" [class.active]="draggingEnabled" color="primary" matTooltip="{{ draggingEnabled ? 'Disable' : 'Enable' }} reordering" (click)="toggleDraggingEnabled()" data-cy="note-builder-reorder-button"><i class="material-icons">reorder</i></button>
    <button mat-button class="action-button drag-button" [disabled]="!hasDragged" *ngIf="draggingEnabled" color="primary" (click)="undoDragChanges()" matTooltip="Undo reorder changes" data-cy="note-builder-undo-button"><i class="material-icons">undo</i></button>
    <button mat-button class="action-button drag-button" [disabled]="!hasDragged" *ngIf="draggingEnabled" color="primary" (click)="saveDragChanges()" matTooltip="Save reorder changes" data-cy="note-builder-save-reorder-button"><i class="material-icons">save</i></button>

    <div class="save-all-spinner" *ngIf="isSaving" matTooltip="Saving changes" data-cy="note-builder-saving-spinner">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>

    <button mat-button class="action-button" color="warn" (click)="cancel()" data-cy="note-builder-cancel-button">Cancel</button>
    <button mat-raised-button class="action-button" color="primary" (click)="save()" data-cy="note-builder-save-button">Ok</button>
  </div>
</div>

<div *ngIf="isLoading" data-cy="note-builder-loading-container">
  <div class="spinner-div" data-cy="note-builder-spinner-div">
    <div class="spinner-holder" data-cy="note-builder-spinner-holder">
      <mat-spinner data-cy="note-builder-spinner"></mat-spinner>
    </div>
  </div>
</div>
